module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"discount-dialog":{"action":"Fortsæt indkøb"}},"de":{"version":1,"discount-dialog":{"action":"Weiter einkaufen"}},"en":{"discount-dialog":{"action":"Weiter einkaufen"}},"fr":{"discount-dialog":{"action":"Continuer mes achats"}},"nl":{"discount-dialog":{"action":"Verder winkelen"}},"pl":{"discount-dialog":{"action":"Kupuj dalej"}}}')
  delete Component.options._Ctor
}
